import Table from '@/mixins/table'
import Dialog from '@/mixins/dialog'

export default {
	mixins: [Table, Dialog]
}